<template>
  <div>
    <div class="detial-cont-title">审批流程图示</div>
    <blank height="1"> </blank>
    <div class="detial-cont-view"></div>
    <blank height="20"> </blank>
    <div class="detial-cont-title">审批轨迹</div>
    <div class="detial-cont-view">
      <a-table :pagination="false" :columns="columns" :data-source="data">
        <template slot="fieldValue1" slot-scope="text, record">
          <div class="check-icons" v-if="record.fieldValue1 === '1'">
            <a-icon type="check" />同意
          </div>
          <div class="close-icons" v-if="record.fieldValue1 === '2'">
            <a-icon type="close" />不同意
          </div>
          <!-- {{ record.fieldValue1 === '1' ? '同意' : '不同意' }} -->
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
const columns = [
  {
    title: '时间',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true
  },
  {
    title: '责任人',
    dataIndex: 'dutyOfficerStr',
    key: 'dutyOfficerStr',
    ellipsis: true
  },
  {
    title: '意见',
    dataIndex: 'fieldValue1',
    key: 'fieldValue1',
    scopedSlots: { customRender: 'fieldValue1' }
  },
  {
    title: '批示',
    dataIndex: 'fieldValue2',
    key: 'fieldValue2'
  }
]
export default {
  data() {
    return {
      columns,
      data: []
    }
  }
}
</script>

<style lang="scss" scoped>
.addClaimExpense {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/standingBook/auditProcess.vue